import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useReveal = () => {
  const location = useLocation();

  useEffect(() => {
    // Small delay to ensure new route's DOM is rendered
    const timer = setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('vis');
            }
          });
        },
        { threshold: 0.15 }
      );

      const elements = document.querySelectorAll('.reveal:not(.vis)');
      elements.forEach((el) => observer.observe(el));

      // Store observer for cleanup
      (window as any).__revealObserver = observer;
    }, 50);

    return () => {
      clearTimeout(timer);
      if ((window as any).__revealObserver) {
        (window as any).__revealObserver.disconnect();
      }
    };
  }, [location.pathname]);
};

export default useReveal;
